// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CommittedAtStartTabQueryVariables = Types.Exact<{
  project: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  costCode?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type CommittedAtStartTabQuery = { __typename?: 'Query', projectCostCodes: { __typename?: 'ProjectCostCodesPageResult', entities: Array<{ __typename?: 'ProjectCostCode', id: string, committedAtStartInCents: number, committedCostInCents: number, revisedCostInCents: number, startCostInCents: number, project:
        | { __typename?: 'StandaloneProject', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
        | { __typename?: 'Region', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
        | { __typename?: 'Market', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
        | { __typename?: 'Community', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
        | { __typename?: 'Subdivision', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
        | { __typename?: 'Lot', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
        | { __typename?: 'Structure', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
        | { __typename?: 'Unit', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number }
      , costCode: { __typename?: 'CostCode', id: string, displayName: string } }> } };

export type CommittedAtStartTab_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, startDate: Types.Scalars['Date']['input'], committedCostCodesAtStartInBasisPoints?: number | null | undefined, committedCostInCents: number, directCostInCents: number };

export type CommittedAtStartTab_ProjectFragment =
  | CommittedAtStartTab_Project_StandaloneProject_Fragment
  | CommittedAtStartTab_Project_Region_Fragment
  | CommittedAtStartTab_Project_Market_Fragment
  | CommittedAtStartTab_Project_Community_Fragment
  | CommittedAtStartTab_Project_Subdivision_Fragment
  | CommittedAtStartTab_Project_Lot_Fragment
  | CommittedAtStartTab_Project_Structure_Fragment
  | CommittedAtStartTab_Project_Unit_Fragment
;

export type CommittedAtStartTab_ProjectCostCodeFragment = { __typename?: 'ProjectCostCode', id: string, committedAtStartInCents: number, committedCostInCents: number, revisedCostInCents: number, startCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string }, project:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
   };

export type CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables = Types.Exact<{
  projectCostCodes: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  commitmentStatus?: Types.InputMaybe<Array<Types.CommitmentStatus> | Types.CommitmentStatus>;
}>;


export type CommittedAtStartTab_CommitmentsByProjectCostCodeQuery = { __typename?: 'Query', commitments: Array<{ __typename?: 'Commitment', id: string, shortName: string, status: Types.CommitmentStatus, statusText: string, project:
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
    , changeOrders: Array<{ __typename?: 'CommitmentChangeOrder', id: string, shortName: string, status: Types.CommitmentStatus, statusText: string, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, costCode: { __typename?: 'CostCode', id: string } }> }>, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, costCode: { __typename?: 'CostCode', id: string } }> }> };

export type CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLike_Commitment_Fragment = { __typename?: 'Commitment', id: string, shortName: string, status: Types.CommitmentStatus, statusText: string, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, costCode: { __typename?: 'CostCode', id: string } }> };

export type CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLike_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, shortName: string, status: Types.CommitmentStatus, statusText: string, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, committedInCents: number, costCode: { __typename?: 'CostCode', id: string } }> };

export type CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLikeFragment =
  | CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLike_Commitment_Fragment
  | CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLike_CommitmentChangeOrder_Fragment
;

export const CommittedAtStartTab_ProjectFragmentDoc = gql`
    fragment CommittedAtStartTab_Project on Project {
  id
  name
  startDate
  committedCostCodesAtStartInBasisPoints
  committedCostInCents
  directCostInCents
}
    `;
export const CommittedAtStartTab_ProjectCostCodeFragmentDoc = gql`
    fragment CommittedAtStartTab_ProjectCostCodeFragment on ProjectCostCode {
  id
  committedAtStartInCents
  committedCostInCents
  revisedCostInCents
  startCostInCents
  costCode {
    ...DisplayNamed
  }
  project {
    id
  }
}
    ${DisplayNamedFragmentDoc}`;
export const CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLikeFragmentDoc = gql`
    fragment CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLike on CommitmentLike {
  id
  shortName
  status
  statusText
  lineItems {
    id
    committedInCents
    costCode {
      id
    }
  }
}
    `;
export const CommittedAtStartTabDocument = gql`
    query CommittedAtStartTab($project: [ID!]!, $costCode: [ID!]) {
  projectCostCodes(filter: {project: $project, costCode: $costCode}) {
    entities {
      ...CommittedAtStartTab_ProjectCostCodeFragment
      project {
        ...CommittedAtStartTab_Project
      }
    }
  }
}
    ${CommittedAtStartTab_ProjectCostCodeFragmentDoc}
${CommittedAtStartTab_ProjectFragmentDoc}`;

/**
 * __useCommittedAtStartTabQuery__
 *
 * To run a query within a React component, call `useCommittedAtStartTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommittedAtStartTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommittedAtStartTabQuery({
 *   variables: {
 *      project: // value for 'project'
 *      costCode: // value for 'costCode'
 *   },
 * });
 */
export function useCommittedAtStartTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables> & ({ variables: CommittedAtStartTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>(CommittedAtStartTabDocument, options);
      }
export function useCommittedAtStartTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>(CommittedAtStartTabDocument, options);
        }
// @ts-ignore
export function useCommittedAtStartTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>;
export function useCommittedAtStartTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommittedAtStartTabQuery | undefined, CommittedAtStartTabQueryVariables>;
export function useCommittedAtStartTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>(CommittedAtStartTabDocument, options);
        }
export type CommittedAtStartTabQueryHookResult = ReturnType<typeof useCommittedAtStartTabQuery>;
export type CommittedAtStartTabLazyQueryHookResult = ReturnType<typeof useCommittedAtStartTabLazyQuery>;
export type CommittedAtStartTabSuspenseQueryHookResult = ReturnType<typeof useCommittedAtStartTabSuspenseQuery>;
export type CommittedAtStartTabQueryResult = Apollo.QueryResult<CommittedAtStartTabQuery, CommittedAtStartTabQueryVariables>;
export const CommittedAtStartTab_CommitmentsByProjectCostCodeDocument = gql`
    query CommittedAtStartTab_CommitmentsByProjectCostCode($projectCostCodes: [ID!]!, $commitmentStatus: [CommitmentStatus!]) {
  commitments(
    filter: {projectCostCodes: $projectCostCodes, status: $commitmentStatus}
  ) {
    ...CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLike
    project {
      id
    }
    changeOrders {
      ...CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLike
    }
  }
}
    ${CommittedAtStartTab_CommitmentsByProjectCostCode_CommitmentLikeFragmentDoc}`;

/**
 * __useCommittedAtStartTab_CommitmentsByProjectCostCodeQuery__
 *
 * To run a query within a React component, call `useCommittedAtStartTab_CommitmentsByProjectCostCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommittedAtStartTab_CommitmentsByProjectCostCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommittedAtStartTab_CommitmentsByProjectCostCodeQuery({
 *   variables: {
 *      projectCostCodes: // value for 'projectCostCodes'
 *      commitmentStatus: // value for 'commitmentStatus'
 *   },
 * });
 */
export function useCommittedAtStartTab_CommitmentsByProjectCostCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables> & ({ variables: CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>(CommittedAtStartTab_CommitmentsByProjectCostCodeDocument, options);
      }
export function useCommittedAtStartTab_CommitmentsByProjectCostCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>(CommittedAtStartTab_CommitmentsByProjectCostCodeDocument, options);
        }
// @ts-ignore
export function useCommittedAtStartTab_CommitmentsByProjectCostCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>;
export function useCommittedAtStartTab_CommitmentsByProjectCostCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery | undefined, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>;
export function useCommittedAtStartTab_CommitmentsByProjectCostCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>(CommittedAtStartTab_CommitmentsByProjectCostCodeDocument, options);
        }
export type CommittedAtStartTab_CommitmentsByProjectCostCodeQueryHookResult = ReturnType<typeof useCommittedAtStartTab_CommitmentsByProjectCostCodeQuery>;
export type CommittedAtStartTab_CommitmentsByProjectCostCodeLazyQueryHookResult = ReturnType<typeof useCommittedAtStartTab_CommitmentsByProjectCostCodeLazyQuery>;
export type CommittedAtStartTab_CommitmentsByProjectCostCodeSuspenseQueryHookResult = ReturnType<typeof useCommittedAtStartTab_CommitmentsByProjectCostCodeSuspenseQuery>;
export type CommittedAtStartTab_CommitmentsByProjectCostCodeQueryResult = Apollo.QueryResult<CommittedAtStartTab_CommitmentsByProjectCostCodeQuery, CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables>;